/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import ReactGA from "react-ga4";
import NewsPublic from '../pages/NewsPublic'
import DocumentView from '../pages/Documents/DocumentView'
/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser, auth} = useAuth()
  let eventGA = {};
  if(currentUser){
    eventGA = {
      categoria_profesional: auth?.categoria ?? '',
      especialidad_profesional: auth?.especialidad ?? '',
      usuario_logueado: 'Si',
      profesional: currentUser.rut
    };
    ReactGA.gtag('set', 'user_properties', eventGA);
  }
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to={auth?.categoria === 'FIRMANTE' ? '/documentos' : '/inicio'} />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path="/noticias/:slug" element={<NewsPublic />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
          <Route path="/documentos/:token" element={<DocumentView />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
